import { useState } from "react";
import client, { apiError } from "@/api/client";
import { PageHeader, Section } from "@/components/PageChrome";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { LockKey, Check } from "@phosphor-icons/react";

export default function ChangePassword() {
  const { user, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await client.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed. Please sign in again.");
      setTimeout(() => { logout(); window.location.href = "/login"; }, 1200);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Change Password" subtitle={`Signed in as ${user.name}`}/>
      <Section>
        <div className="max-w-md">
          <form onSubmit={save} className="bg-white border border-orange-200 rounded-sm p-6" data-testid="change-password-form">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-sm bg-orange-100 text-orange-700 grid place-items-center">
                <LockKey size={20} weight="duotone" />
              </div>
              <div>
                <div className="label-cap">Security</div>
                <div className="font-display font-bold text-lg text-orange-950">Update your password</div>
              </div>
            </div>

            <label className="label-cap">Current Password</label>
            <Input data-testid="cp-current-input" type="password" value={current} onChange={(e)=>setCurrent(e.target.value)} required className="mb-4"/>

            <label className="label-cap">New Password</label>
            <Input data-testid="cp-new-input" type="password" value={next} onChange={(e)=>setNext(e.target.value)} required minLength={6} className="mb-4"/>

            <label className="label-cap">Confirm New Password</label>
            <Input data-testid="cp-confirm-input" type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} required minLength={6} className="mb-5"/>

            <Button type="submit" disabled={busy} data-testid="cp-submit-btn" className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-sm h-11">
              <Check size={16} weight="bold" className="mr-1"/> {busy ? "Updating…" : "Change Password"}
            </Button>

            <p className="mt-4 text-xs text-orange-800/70">
              You'll be signed out and asked to log in with your new password.
            </p>
          </form>
        </div>
      </Section>
    </div>
  );
}
